<template>
  <div class="container my-3">
    <div style="text-align: center">
      <loading :active.sync="carregando" :is-full-page="true"></loading>
    </div>

    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i }}
        </b-alert>
      </p>
    </div>

    <form @submit.prevent>
      <h2 class="title">Relatório de débitos protestados</h2>
      <b-card v-if="origemAcesso === 'AD' || origemAcesso === 'GovBr'">
        <h2 class="title">Dados do requerente</h2>
        <div></div>
        <b-row class="mb-0">
          <b-col sm="2" md="2"> </b-col>
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="cpf" class="pb-3">CPF/CNPJ</label>
          </b-col>
          <b-col sm="8" md="4" align-self="start">
            <b-form-input id="cpfCnpj" class="ml-3" type="search" :disabled="!(origemAcesso === 'AD')"
              v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
              v-model="cadastroNacional" 
              style="text-transform: uppercase"
              @keyup="preencheCadastroNacional()">
            </b-form-input>
            <small id="cpfCnpj" :class="erroValidacaoCadastroNacional" class="ml-3 form-text">
              {{ mensagemValidacaoCadastroNacional }}
            </small>
          </b-col>
        </b-row>
        <b-row class="mb-2 mt-3">
          <b-col sm="2" md="2"> </b-col>
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="nomeContribuinte" class="pb-3">Nome / Razão Social</label>
          </b-col>
          <b-col sm="8" md="4" align-self="start">
            <b-form-input id="nomeContribuinte" class="ml-3" v-model="nomeRazaoSocial" :disabled="true">
            </b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <div v-if="cnpjsRelacionadosTabela.length > 0">
            <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
              title="Lista de CNPJ associados ao CPF logado.">
              Opções para visualizar débitos como representante legal ou
              procurador
              <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
            </span>
          </div>
        </b-row>

        <div
          class="mt-3 mb-2 mt-0"
          v-if="cnpjsRelacionadosTabela.length > 0"
        >
          <tabelaListagemCNPJ
            :rows="cnpjsRelacionadosTabela"
            :forca-limpar-campos="forcaLimparCamposListagemCnpj"
            @update:selecionado="handleCnpjTabelaSelecionado"
          />
        </div>

        <b-row class="mb-0 float-right">
          <b-button variant="secondary" class="float-right" @click="() => limparCampos()">
            <span v-if="cnpjsRelacionadosTabela.length > 0 && origemAcesso === 'GovBr'">
              Retornar para CPF
            </span>
            <span v-else> Limpar </span>
          </b-button>
          <div v-if="exibeBtnPesquisar">
            <b-button variant="primary" class="ml-3 mr-3 float-right" :disabled="!preencheCadastroNacionalOK"
              @click.prevent="() => pesquisar()">
              Pesquisar
            </b-button>
          </div>
          <div v-else>
            <b-button variant="success" class="ml-3 mr-3 float-right" :disabled="!preencheCadastroNacionalOK"
              @click.prevent="() => emitirRelatório()">
              Emitir relatório
            </b-button>
          </div>
        </b-row>
      </b-card>
    </form>
  </div>
</template>

<script>
import routes from "../routes/routes";
import { mask } from "vue-the-mask";
import constantes from "../constants/index";
import formatador from "../utils/formatarCampos";
import { validarCPF, validarCNPJ } from '@at-siatu-tributario/tipo-identificador';
import loading from "vue-loading-overlay";
import tabelaListagemCNPJ from "../components/compartilhados/tabelaListagemCNPJ.vue";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    loading,
    tabelaListagemCNPJ,
  },
  directives: {
    mask,
  },
  data() {
    return {
      carregando: false,
      token: "",

      mensagemErro: [],
      mensagemSucesso: [],

      urlGuia: "",
      idPessoaCriptografado: "",

      origemAcesso: "",
      exibeBtnPesquisar: true,

      cnpjsRelacionadosTabela: [],
      forcaLimparCamposListagemCnpj: false,
      cnpjSelecionado: "",

      preencheCadastroNacionalOK: false,

      mensagemValidacaoCadastroNacional: "",
      erroValidacaoCadastroNacional: "",

      cadastroNacional: "",
      nomeRazaoSocial: "",
    };
  },


  watch: {
    cadastroNacional(newValue) {
      this.limparmensagemValidacao();
      if (newValue.length > 0) {
        this.preencheCadastroNacional();
      } else {
        this.preencheCadastroNacionalOK = false;
        this.exibeBtnPesquisar = true;
        this.nomeRazaoSocial = "";
      }
    },
  },

  async beforeMount() {
    this.origemAcesso = this.$store.getters.userInfo.origem;
    if (this.origemAcesso !== "GovBr" || this.origemAcesso !== "AD")
      routes.push({ to: "Landing" });
    if (this.origemAcesso === "GovBr") {
      this.cadastroNacional = this.$store.getters.userInfo.preferred_username;
      this.nomeRazaoSocial = this.$store.getters.userInfo.name.toUpperCase();
      this.exibeBtnPesquisar = false;
      this.preencheCadastroNacionalOK = true;
      this.buscarCNPJSRelacionados();
    }
  },

  methods: {
    limparCampos(opcoes = {}) {
      if (this.origemAcesso === "GovBr") {
        this.cadastroNacional = this.$store.getters.userInfo.preferred_username;
        if (this.cadastroNacional.length === 11) {
          this.cadastroNacional = formatador.formataCPF(this.cadastroNacional);
        } else {
          this.cadastroNacional = formatador.formataCNPJ(this.cadastroNacional);
        }
        this.nomeRazaoSocial = this.$store.getters.userInfo.name.toUpperCase();
      } else {
        this.cadastroNacional = "";
        this.nomeRazaoSocial = "";
      }
      this.cnpjSelecionado = "";
      this.exibeBtnPesquisar = true;

      if (opcoes.ignora_forcar_limpar_campos_listagem_cnpj !== true) {
        this.forcaLimparCamposListagemCnpj = !this.forcaLimparCamposListagemCnpj;
      }
    },

    montaSelecionado(codigoNacional, razaoSocial) {
      this.cadastroNacional = codigoNacional;
      this.nomeRazaoSocial = razaoSocial;
    },

    emitirRelatório: function () {
      if (this.origemAcesso === "GovBr") {
        this.pesquisar();
      } else {
        this.downloadArquivo(this.urlGuia, "emissaoRelatorioDRAM");
      }
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl)

    },

    buscarCNPJSRelacionados: async function () {
      this.carregando = true;
      await this.$axios
        .get(
          `${this.$env.url_backend}${constantes.buscarCNPJRelacionados}?cpf=${this.$store.getters.userInfo.preferred_username}`
        )
        .then((response) => {
          this.cnpjsRelacionadosTabela = response.data.cnpjRelacionados.listaEstabelecimento.map((valor) => {
            return {
              cnpj: valor.cnpj,
              cnpj_limpo: valor.cnpj.replace(/\D/g, ""),
              nome: valor.nome,
              selecionado: false,
            };
          });
          this.carregando = false;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          console.log(mensagem);
          this.carregando = false;
        });
    },

    preencheCadastroNacional: function () {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.cadastroNacional.length;

      this.preencheCadastroNacionalOK = false;

      //CPF
      if (tipo <= 14) {
        tamCampo = 14;
        txt = "CPF";
      } else {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }
      if (this.cadastroNacional.length <= tamCampo) {
        this.mensagemValidacaoCadastroNacional =
          txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCadastroNacionalOK = false;
      }
      if (tipo == 14) {
        if (validarCPF(this.cadastroNacional)) {
          this.mensagemValidacaoCadastroNacional = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCadastroNacionalOK = true;
        } else {
          this.mensagemValidacaoCadastroNacional =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCadastroNacionalOK = false;
        }
      }
      // cnpj
      else if (tipo == 18) {
        if (validarCNPJ(this.cadastroNacional)) {
          this.mensagemValidacaoCadastroNacional = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCadastroNacionalOK = true;
        } else {
          this.mensagemValidacaoCadastroNacional =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCadastroNacionalOK = false;
        }
      }
      this.erroValidacaoCadastroNacional = formato;

      if (this.cadastroNacional === "") {
        this.mensagemValidacaoCadastroNacional = "";
      }
    },

    limparmensagemValidacao: function () {
      if (this.cadastroNacional == "" || this.cadastroNacional == null) {
        this.mensagemValidacaoCadastroNacional = "";
      }
    },

    async retornaToken() {
      try {
        return await window.grecaptcha.enterprise.execute(this.$env.recaptchaSiteKey, {
          action: "index",
        })
      } catch (error) {
        console.log(error)
        return null;
      }
    },

    pesquisar: async function () {
      this.token = await this.retornaToken();

      if (!this.token) {
        this.mensagemErro.push("Erro token não inicializada. Tente novamente mais tarde.");
      }
      try {
        this.mensagemErro = [];
        this.mensagemSucesso = [];        
        await this.$axios
          .post(this.$env.url_backend + constantes.buscarPessoaPeloCPFCNPJ, {
            cpfCnpj: this.cadastroNacional,
            recaptchaToken: this.token,
            recaptchaSiteKey: this.$env.recaptchaSiteKey,
            recaptchaAction: "index",
          })
          .then((response) => {                
            this.nomeRazaoSocial = response.data.pessoa.NOME;
            this.idPessoaCriptografado = response.data.idPessoaCriptografado;
            this.urlGuia = `${this.$env.url_cobranca}/emissor/relacao_protesto?id=${this.idPessoaCriptografado}`;
            if (this.origemAcesso === "GovBr") {
              this.downloadArquivo(this.urlGuia, "emissaoDRAM");
            }
            this.carregando = false;
            this.exibeBtnPesquisar = false;
          })
          .catch((err) => {
            this.carregando = false;
            const mensagem = normalizaMensagemApi(err);
            this.mensagemErro.push(mensagem);
            window.scrollTo(0, 0);
          });          
      } catch (error) {        
        this.carregando = false;
        const mensagem = normalizaMensagemApi(error);
        this.mensagensErro(mensagem);
        window.scrollTo(0, 0);
      }
    },

    mensagensErro(error) {
      if (Array.isArray(error)) {
        error.forEach((erro) => {
          this.mensagemErro.push(erro.msg);
        });
        return;
      }
      const mensagem = normalizaMensagemApi(error);
      this.mensagemErro.push(mensagem);
    },

    handleCnpjTabelaSelecionado(values) {
      if (!values || !values.codigoNacional) {
        return;
      }
      this.limparCampos({ ignora_forcar_limpar_campos_listagem_cnpj: true });
      // aguarda um momento para garantir que o DOM foi atualizado
      this.$nextTick(() => {
        const cnpj = formatador.formataCNPJ(values.codigoNacional);
        this.montaSelecionado(cnpj, values.razaoSocial);
      });
    },
  },
};
</script>

<style scoped></style>
